(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7212],{

/***/ 44146:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blockquiry_chat",
      function () {
        return __webpack_require__(79082);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Chat; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Fade__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(9942);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13264);
/* harmony import */ var _src_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5786);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(93706);
/* harmony import */ var remark_gfm__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(14769);
/* harmony import */ var remark_math__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(30399);
/* harmony import */ var rehype_katex__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(80399);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(30120);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(81401);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(44731);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(21448);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(70754);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70917);
/* harmony import */ var _styles_Test_module_css__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(59740);
/* harmony import */ var _styles_Test_module_css__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_styles_Test_module_css__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _src_components_blockquiry_chat_components_ChatFooter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4019);
/* harmony import */ var _src_components_blockquiry_chat_components_ChatHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18609);
/* harmony import */ var _mui_icons_material_PermIdentityOutlined__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(35881);
/* harmony import */ var _src_components_accountdetails_copypaste_CopyChat__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59548);
/* harmony import */ var _src_utils_LightTooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14569);
/* eslint-disable no-unused-vars */ /* eslint-disable jsx-a11y/no-autofocus */ /* eslint-disable react/no-array-index-key */ /* eslint-disable no-nested-ternary */ 




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















// Custom link component
var CustomLink = function(param) {
    var href = param.href, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
        href: href,
        style: {
            textDecoration: "underline"
        },
        target: "_blank",
        rel: "noopener noreferrer",
        children: children
    });
};
// Map 'a' tag to the CustomLink component
var components = {
    a: CustomLink
};
var TooltipTypo = (0,_mui_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.7500rem",
        fontWeight: "normal",
        letterSpacing: ".0107142857em",
        // alignItems: 'center',
        color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary,
        textAlign: "left"
    };
});
var SourceTypo = (0,_mui_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.87500rem",
        lineHeight: "1.00rem",
        fontWeight: 500,
        letterSpacing: ".0107142867em",
        // alignItems: 'center',
        color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary,
        textAlign: "left"
    };
});
var loadingGradient = (0,_mui_system__WEBPACK_IMPORTED_MODULE_11__/* .keyframes */ .F4)(_templateObject());
var fadeInMessage = (0,_mui_system__WEBPACK_IMPORTED_MODULE_11__/* .keyframes */ .F4)(_templateObject1());
var userMessageStyle = {
    background: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary,
    padding: "0.75rem",
    fontFamily: "Roboto,arial,sans-serif",
    fontSize: "1.00rem",
    color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_surface */ .T.token_surface,
    margin: "0.325rem",
    borderRadius: "0.5rem"
};
var userMessageWaitingStyle = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
    padding: "0.75rem",
    borderRadius: "0.5rem",
    fontFamily: "Roboto,arial,sans-serif",
    fontSize: "1.00rem",
    margin: "0.325rem",
    color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_surface */ .T.token_surface,
    background: "linear-gradient(to left, #0A2B3B, #082B3B, #0C3F5A, #156D9F, #0C5678, #0D334D)",
    backgroundSize: "200% 200%",
    backgroundPosition: "-100% 0",
    animation: "loading-gradient 2s ease-in-out infinite",
    animationDirection: "alternate"
}, "animation", "".concat(loadingGradient, " 2s ease-in-out infinite alternate"));
var apiMessageStyle = {
    background: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_300 */ .T.token_grey_300,
    padding: "0.75rem",
    fontFamily: "Roboto,arial,sans-serif",
    fontSize: "1.00rem",
    color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary,
    animation: "fadein 0.5s",
    margin: "0.325rem",
    borderRadius: "0.5rem"
};
var BlockTypo = (0,_mui_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "play",
        opacity: 1,
        fontSize: "1.75rem",
        fontWeight: 700,
        lineHeight: "1.25rem",
        textAlign: "center",
        paddingLeft: 0,
        whiteSpace: "wrap",
        color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_secondary */ .T.palette_secondary
    };
});
var __N_SSP = true;
function Chat(param) {
    var chatUserId = param.chatUserId;
    console.log("chatUserId in Chat component", chatUserId);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), visibleApiMessages = ref[0], setVisibleApiMessages = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), userInput = ref1[0], setUserInput = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), history = ref2[0], setHistory = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([
        {
            message: "Hello! How can I help?",
            type: "apiMessage"
        }, 
    ]), messages = ref4[0], setMessages = ref4[1];
    var messageListRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var textAreaRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    // Auto scroll chat to bottom
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var messageList = messageListRef.current;
        messageList.scrollTop = messageList.scrollHeight;
    }, [
        messages
    ]);
    // Focus on text field on load
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        textAreaRef.current.focus();
    }, []);
    // Handle errors
    var handleError = function() {
        setMessages(function(prevMessages) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(prevMessages).concat([
                {
                    message: "Oops! There seems to be an error. Please try again.",
                    type: "apiMessage"
                }, 
            ]);
        });
        setLoading(false);
        setUserInput("");
    };
    // Handle form submission
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(e) {
            var response, result;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (userInput.trim() === "") {
                            return [
                                2
                            ];
                        }
                        setLoading(true);
                        setMessages(function(prevMessages) {
                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(prevMessages).concat([
                                {
                                    message: userInput,
                                    type: "userMessage"
                                }, 
                            ]);
                        });
                        return [
                            4,
                            fetch("/api/chat_api/chat_qa_v2", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    question: userInput,
                                    history: history
                                })
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response.ok) {
                            handleError();
                            return [
                                2
                            ];
                        }
                        // Reset user input
                        setUserInput("");
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        result = _state.sent();
                        setMessages(function(prevMessages) {
                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(prevMessages).concat([
                                {
                                    message: result.response.text,
                                    type: "apiMessage",
                                    metadata: result.metadata
                                }, 
                            ]);
                        });
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    // Prevent blank submissions and allow for multiline input
    var handleEnter = function(e) {
        if (e.key === "Enter" && userInput) {
            if (!e.shiftKey && userInput) {
                handleSubmit(e);
            }
        } else if (e.key === "Enter") {
            e.preventDefault();
        }
    };
    var ChatBubbleBox = function(message, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            component: _mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z,
            className: "chat-bubble-box",
            sx: message.type === "userMessage" && loading && index === messages.length - 1 ? userMessageWaitingStyle : message.type === "apiMessage" ? apiMessageStyle : userMessageStyle,
            style: {
                position: "relative",
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                marginTop: "0.65rem"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    sx: {
                        position: "absolute",
                        padding: "0.25rem",
                        top: 0,
                        right: 0,
                        color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_components_accountdetails_copypaste_CopyChat__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        stringToCopy: message.message
                    })
                }),
                message.type === "apiMessage" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                    variant: "rounded",
                    sx: {
                        bgcolor: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_surface */ .T.token_surface,
                        width: "28px",
                        height: "28px",
                        // marginRight: '1rem',
                        borderRadius: "0.25rem"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlockTypo, {
                        children: "b"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                    variant: "rounded",
                    sx: {
                        bgcolor: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_surface */ .T.token_surface,
                        width: "28px",
                        height: "28px",
                        // marginRight: '1rem',
                        borderRadius: "0.25rem"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_PermIdentityOutlined__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        sx: {
                            color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    className: "chat-message-box",
                    sx: {
                        lineHeight: "1.75rem",
                        marginLeft: "0.50rem",
                        paddingTop: "0.25rem",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_20__/* .ReactMarkdown */ .D, {
                            remarkPlugins: [
                                remark_gfm__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z,
                                remark_math__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z,
                                rehype_katex__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z
                            ],
                            components: components,
                            children: message.message
                        }),
                        message.type === "apiMessage" && // index === messages.length - 1 &&
                        message.metadata && message.metadata.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            className: "lower-border",
                            sx: {
                                display: "flex",
                                flexDirection: {
                                    xs: "column",
                                    md: "column"
                                },
                                alignItems: "left",
                                width: "100%",
                                flexGrow: 1
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    sx: {
                                        borderBottom: "1px solid ".concat(_src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_surface */ .T.token_surface),
                                        width: "100%",
                                        marginBottom: "8px"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    sx: {
                                        display: "flex",
                                        flexDirection: {
                                            xs: "column",
                                            md: "row"
                                        },
                                        alignItems: "center",
                                        flexWrap: "wrap"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SourceTypo, {
                                            children: "Learn more:"
                                        }),
                                        message.metadata.map(function(meta, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_utils_LightTooltip__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TooltipTypo, {
                                                    children: meta.title
                                                }),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                                    size: "small",
                                                    label: meta.root_id,
                                                    clickable: true,
                                                    component: "a",
                                                    href: meta.source,
                                                    target: "_blank" // Open the link in a new tab
                                                    ,
                                                    variant: "outlined",
                                                    sx: {
                                                        // border: `${tokens.token_surface}`,
                                                        color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary,
                                                        bgcolor: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_50 */ .T.token_grey_50,
                                                        marginLeft: "0.5rem"
                                                    }
                                                }, meta.id)
                                            });
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }, index);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var historyStartIndex = messages.length - 3;
        if (historyStartIndex < 0) {
            historyStartIndex = 0;
        }
        setHistory(messages.slice(historyStartIndex, messages.length).map(function(msg) {
            return msg.message;
        }));
    }, [
        messages
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                        children: "blockquiry Chat | AI Chat Agent for Crypto and Cybercrime Related Questions"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "description",
                        content: "AI-powered chat agent specifically trained to help victims of crypto and cybercrime. Get assistance in understanding crypto regulation, privacy, and more."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "keywords",
                        content: "blockquiry, AI, cryptocurrency, chat agent, cybercrime victims, cryptocrime victims, crypto regulation, privacy, blockchain economy"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "author",
                        content: "blockquiry"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:title",
                        content: "AI Chat Agent for Crypto and Cybercrime Related Questions"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:description",
                        content: "AI-powered chat agent specifically trained to help victims of crypto and cybercrime. Get assistance in understanding crypto regulation, privacy, and more."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:image",
                        content: "/blockquiry92x21.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_components_blockquiry_chat_components_ChatHeader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                className: "main-chat-box",
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: {
                        xs: "0.25rem",
                        md: "1.25rem"
                    },
                    backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_surface */ .T.token_surface
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        component: _mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z,
                        elevation: 0,
                        sx: {
                            width: {
                                xs: "98vw",
                                md: "75vw"
                            },
                            height: {
                                xs: "75vh",
                                md: "70vh"
                            },
                            border: "1px solid ".concat(_src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_table_bottom_border */ .T.token_table_bottom_border),
                            bgcolor: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_100 */ .T.token_grey_100,
                            borderRadius: "0.5rem",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            "& ::-webkit-scrollbar": {
                                // Hide scrollbar for Chrome, Safari and Opera
                                display: "none"
                            },
                            "& ::-ms-overflow-style": {
                                // Hide scrollbar for IE and Edge
                                display: "none"
                            },
                            "& scrollbarWidth": {
                                // Hide scrollbar for Firefox
                                display: "none"
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            sx: {
                                width: "100%",
                                height: "100%",
                                overflowY: "scroll",
                                borderRadius: "0.5rem"
                            },
                            ref: messageListRef,
                            children: messages.map(function(message, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: message.type === "apiMessage" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Fade__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                        in: true,
                                        timeout: 2000,
                                        children: ChatBubbleBox(message, index)
                                    }) : ChatBubbleBox(message, index)
                                });
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        className: "search-input-box",
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            paddingTop: {
                                xs: "0.50rem",
                                md: "2.00rem"
                            },
                            paddingBottom: {
                                xs: "0.50rem",
                                md: "1.00rem"
                            },
                            paddingRight: {
                                xs: "0.25rem",
                                md: "1rem"
                            },
                            paddingLeft: {
                                xs: "0.25rem",
                                md: "1rem"
                            },
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("textarea", {
                                            disabled: loading,
                                            onKeyDown: handleEnter,
                                            ref: textAreaRef,
                                            autoFocus: false,
                                            rows: 1,
                                            maxLength: 512,
                                            type: "text",
                                            id: "userInput",
                                            name: "userInput",
                                            placeholder: loading ? "Waiting for response..." : "Type your message...",
                                            value: userInput,
                                            onChange: function(e) {
                                                return setUserInput(e.target.value);
                                            },
                                            className: (_styles_Test_module_css__WEBPACK_IMPORTED_MODULE_26___default().textarea),
                                            style: {
                                                position: "relative",
                                                resize: "none",
                                                fontSize: "1.00rem",
                                                fontFamily: "Roboto",
                                                padding: "1.00rem 1.00rem",
                                                // width: '97vw',
                                                borderRadius: "0.5rem",
                                                border: "1px solid ".concat(_src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_search_border_grey */ .T.token_search_border_grey),
                                                boxShadow: "0 4px 12px rgb(60 63 66 / 15%)",
                                                background: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_surface */ .T.token_surface,
                                                color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_text_grey_on_white */ .T.token_text_grey_on_white,
                                                outline: "none",
                                                "::placeholder": {
                                                    color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_300 */ .T.token_grey_300
                                                },
                                                "&:disabled": {
                                                    opacity: 0.5
                                                },
                                                "&:hover": {
                                                    boxShadow: "1px 1px 6px rgb(32 33 36 / 28%)"
                                                }
                                            },
                                            sx: {
                                                xs: "100vw",
                                                md: "75vw"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                            type: "submit",
                                            disabled: loading,
                                            style: {
                                                position: "absolute",
                                                top: "0.87rem",
                                                right: "1rem",
                                                color: "rgb(165, 162, 162)",
                                                background: "none",
                                                padding: "0.3rem",
                                                border: "none",
                                                display: "flex"
                                            },
                                            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                sx: {
                                                    position: "absolute",
                                                    top: "0.2rem",
                                                    right: "0.25rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                                        color: "inherit",
                                                        size: 20
                                                    }),
                                                    " "
                                                ]
                                            }) : // Send icon SVG in input field
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                                                viewBox: "0 0 20 20",
                                                style: {
                                                    transform: "rotate(90deg)",
                                                    width: "1.2em",
                                                    height: "1.2em",
                                                    fill: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_apple_grey */ .T.token_apple_grey
                                                },
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                    d: "M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                sx: {
                                    display: {
                                        xs: "none",
                                        sm: "none"
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_components_blockquiry_chat_components_ChatFooter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1265,3517,4540,3835,1816,5426,517,2390,247,7575,8653,5543,7155,5696,447,9115,9774,2888,179], function() { return __webpack_exec__(44146); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);